module.exports = __webpack_public_path__ + "static/media/09.8b5bd389.jpg";